import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import axios from "axios";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: '/home',
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  // {
  //   path: "/search",
  //   name: "Search",
  //   component: () =>
  //     import(/* webpackChunkName: "search" */ "../views/Search.vue"),
  // },
  {
    path: "/data",
    name: "Data",
    component: () => import(/* webpackChunkName: "data" */ "../views/Data.vue"),
  },
  {
    path: "/assessintro",
    name: "AssessIntro",
    component: () =>
      import(/* webpackChunkName: "assessintro" */ "../views/AssessIntro.vue"),
  },

  {
    path: "/results",
    name: "Results",
    component: () =>
      import(/* webpackChunkName: "results" */ "../views/Results.vue"),
  },

  {
    path: "/results-sub/:content",
    name: "Results-sub",
    component: () =>
      import(/* webpackChunkName: "results" */ "../views/Results-sub.vue"),
  },
  // {
  //   path: "/city",
  //   name: "City",
  //   component: () => import(/* webpackChunkName: "city" */ "../views/City.vue"),
  //   props: (route) => ({ query: route.query.cityname }),
  // },
  // {
  //   path: "/area",
  //   name: "Area",
  //   component: () => import(/* webpackChunkName: "area" */ "../views/Area.vue"),
  //   props: (route) => ({ query: route.query.cityname }),
  // },

  {
    path: "/reports",
    name: "Reports",
    component: () =>
      import(/* webpackChunkName: "report" */ "../views/Reports.vue"),
  },

  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
  },
];





const router = new VueRouter({
  routes,
  // mode: "history",
  base: "/AQAssess/",
});

export default router;
